/*
  Seccion "Ropa deportiva" de la portada.

  Hace dos cosas:
  - Filtrar el carril por categoria sin recargar la pagina. Todas las tarjetas
    ya vienen en el HTML, asi que el filtro es instantaneo y no hay estado de
    carga que diseñar ni peticion que pueda fallar.
  - Mover el carril con las flechas de escritorio y mantenerlas apagadas cuando
    no hay mas hacia ese lado.
*/

class CostaRopa extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-costa-ropa-track]');
    if (!this.track) return;

    this.chips = Array.from(this.querySelectorAll('[data-costa-ropa-chip]'));
    this.items = Array.from(this.track.querySelectorAll('[data-cat]'));
    this.status = this.querySelector('[data-costa-ropa-status]');
    this.arrows = Array.from(this.querySelectorAll('[data-costa-ropa-arrow]'));

    this.chips.forEach((chip) => {
      chip.addEventListener('click', () => this.filter(chip));
    });

    this.arrows.forEach((arrow) => {
      arrow.addEventListener('click', () => this.scrollByPage(arrow.dataset.costaRopaArrow));
    });

    this.updateArrows = this.updateArrows.bind(this);
    this.track.addEventListener('scroll', this.updateArrows, { passive: true });
    window.addEventListener('resize', this.updateArrows);
    this.updateArrows();
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.updateArrows);
  }

  filter(chip) {
    const category = chip.dataset.costaRopaChip;

    this.chips.forEach((other) => {
      other.setAttribute('aria-pressed', String(other === chip));
    });

    let shown = 0;
    this.items.forEach((item) => {
      // Una prenda puede pertenecer a varias categorias; data-cat las trae
      // separadas por espacio.
      const match = category === 'all' || item.dataset.cat.split(' ').includes(category);
      item.hidden = !match;
      if (match) shown += 1;
    });

    // Filtrar sin volver al principio deja al usuario mirando un hueco.
    this.track.scrollTo({ left: 0, behavior: 'auto' });
    this.updateArrows();

    if (this.status) {
      const label = chip.textContent.trim();
      this.status.textContent =
        shown === 1 ? `1 producto en ${label}` : `${shown} productos en ${label}`;
    }
  }

  scrollByPage(direction) {
    const step = this.track.clientWidth;
    this.track.scrollBy({ left: direction === 'prev' ? -step : step });
  }

  updateArrows() {
    if (!this.arrows.length) return;

    const { scrollLeft, scrollWidth, clientWidth } = this.track;
    // Un pixel de margen: los navegadores redondean scrollLeft y la flecha de
    // "siguiente" se quedaria activa para siempre al final del carril.
    const atStart = scrollLeft <= 1;
    const atEnd = scrollLeft + clientWidth >= scrollWidth - 1;

    this.arrows.forEach((arrow) => {
      const disabled = arrow.dataset.costaRopaArrow === 'prev' ? atStart : atEnd;
      arrow.disabled = disabled;
    });
  }
}

if (!customElements.get('costa-ropa')) {
  customElements.define('costa-ropa', CostaRopa);
}
